function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#8B96A6;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M49,42.6l1-5.1l1,5.1c1.9,9.5,9.3,16.9,18.8,18.8l5.1,1l-5.1,1c-9.5,1.9-16.9,9.3-18.8,18.8l-1,5.1l-1-5.1 c-1.9-9.5-9.3-16.9-18.8-18.8l-5.1-1l5.1-1C39.6,59.6,47.1,52.1,49,42.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.7,19.2l0.5-2.6l0.5,2.6c1,4.8,4.7,8.5,9.4,9.4l2.6,0.5l-2.6,0.5c-4.8,0.9-8.5,4.7-9.4,9.4l-0.5,2.6 l-0.5-2.6c-1-4.8-4.7-8.5-9.4-9.4l-2.6-0.5l2.6-0.5C24,27.7,27.7,24,28.7,19.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M70.5,22.5l0.3-1.7l0.3,1.7c0.6,3.2,3.1,5.6,6.3,6.3l1.7,0.3l-1.7,0.3c-3.2,0.6-5.6,3.1-6.3,6.3l-0.3,1.7 l-0.3-1.7c-0.6-3.2-3.1-5.6-6.3-6.3l-1.7-0.3l1.7-0.3C67.4,28.2,69.9,25.7,70.5,22.5z"
});

function SvgChatbot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/Chatbot.3c744925.svg";
export { ForwardRef as ReactComponent };